<!-- 登录弹窗 -->
<template>
	<div>
		<!-- 完善用户名密码信息弹窗 -->
		<el-dialog width="400px" :modal-append-to-body='false' :show-close='false' :close-on-click-modal='false' :visible.sync="isShow">
			<el-form class="login-box">
				<div class="login-title">{{oldName != '' ? '重置密码' : '完善信息'}}</div>
				<el-form-item class="login-item">
					<el-input v-model="setLoginName" placeholder="请输入用户名" :disabled="oldName != ''"></el-input>
				</el-form-item>
				<el-form-item class="login-item">
					<el-input v-model="setLoginPwd" minlength="6" maxlength="20" placeholder="请输入密码" show-password></el-input>
				</el-form-item>
				<el-form-item class="login-item">
					<el-input v-model="resetLoginPwd" minlength="6" maxlength="20" placeholder="请输入确认密码" show-password></el-input>
				</el-form-item>
				<div class="pwd-strength-row">
					<span class="pwd-strength-label">密码强度</span>
					<span class="pwd-strength-bars" :class="passwordStrength.className">
						<i></i>
						<i></i>
						<i></i>
					</span>
					<span class="pwd-strength-text">{{passwordStrength.text}}</span>
				</div>
				<div class="pwd-rule-tip">
					<div>1. 密码长度为 6~20 位；</div>
					<div>2. 只能输入数字、字母和字符；</div>
				</div>
				<el-form-item class="login-item" style="margin-top: 20px;">
					<el-button class="btn-login" type="danger" @click="setLoginNamePwd" :loading="confirmClicked">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import utils from '../../utils/common-utlis.js'
	import { getCustomerInfo, updateCustomerNameAndPwd } from '../../utils/api-utils/api-customer.js';
	export default {
		name: 'name-pwd-dialog',
		props: {
			isShow: {
				type: Boolean,
				default: false
			},
			oldName: {
				type: String,
				default: ''
			},
			tel: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				showCompleteInfo: false, //完善信息弹窗（用户名密码）
				confirmClicked: false, //完善信息按钮已点击
				setLoginName: "", //登录名
				setLoginPwd: "", //登录密码
				resetLoginPwd: "", //登录密码
				phone: ''
			}
		},
		mounted() {},
		computed: {
			passwordStrength() {
				return this.getPasswordStrength(this.setLoginPwd);
			}
		},
		watch: {
			oldName() {
				this.setLoginName = this.oldName;
			},
			tel() {
				this.phone = this.tel;
			}
		},
		methods: {
			/**
			 * 完善信息
			 */
			async setLoginNamePwd() {
				let _this = this;

				//关闭所有警告
				_this.$message.closeAll();

				// 检测用户名是否输入
				if (!_this.setLoginName) {
					return _this.$message.error('请输入用户名');
				}

				// 检测密码是否输入
				if (!_this.setLoginPwd) {
					return _this.$message.error('请输入密码');
				}
				if (_this.setLoginPwd.length < 6) {
					return _this.$message.error('请至少输入6位数密码');
				}

				// 检测密码是否输入
				if (!_this.resetLoginPwd) {
					return _this.$message.error('请输入确认密码');
				}

				// 检测密码是否相同
				if (_this.resetLoginPwd != _this.setLoginPwd) {
					return _this.$message.error('两次密码不相同');
				}

				// 更新用户用户名密码
				if (!/^[\x21-\x7E]{6,20}$/.test(_this.setLoginPwd)) {
					return _this.$message.error('密码需为6-20位数字、字母或字符');
				}

				_this.confirmClicked = true;
				let customerInfo = await getCustomerInfo();
				let result;
				if (!!customerInfo.customerId) {
					result = await updateCustomerNameAndPwd({ validateRepeatName: this.oldName == '', customerId: customerInfo.customerId, loginName: _this.setLoginName, loginPwd: btoa(encodeURIComponent(_this.setLoginPwd)) });
					_this.confirmClicked = false;
					if (result !== true) {
						return _this.$message.error(result);
					}
				}

				// 保存成功
				this.$emit('success');
			},
			getPasswordStrength(password) {
				if (!password || password.length < 6) {
					return {
						text: '',
						className: ''
					};
				}

				const hasNumber = /\d/.test(password);
				const hasLetter = /[a-zA-Z]/.test(password);
				const hasSymbol = /[^a-zA-Z0-9]/.test(password);
				const typeCount = [hasNumber, hasLetter, hasSymbol].filter(Boolean).length;

				if (password.length >= 10 && typeCount >= 3) {
					return {
						text: '强',
						className: 'strong'
					};
				}
				if (password.length >= 8 && typeCount >= 2) {
					return {
						text: '中',
						className: 'medium'
					};
				}
				return {
					text: '弱',
					className: 'weak'
				};
			},
		}
	}
</script>

<style scoped="scoped">
	.login-box {
		padding: 0 50px 30px 50px;
	}

	.login-title {
		text-align: center;
		font-size: 26px;
		margin-bottom: 50px;
	}

	.login-item {
		margin-bottom: 20px;
	}

	.input-vcode {
		width: 138px;
	}

	.btn-vcode {
		margin-left: 10px;
		width: 112px;
	}

	.btn-login {
		width: 100%;
	}

	.btn-change-type {
		border: 1px solid #f56c6c;
		color: #f56c6c;
	}

	.pwd-strength-row {
		display: flex;
		align-items: center;
		margin: 4px 0 14px;
		font-size: 14px;
		color: #303133;
	}

	.pwd-strength-label {
		width: 70px;
	}

	.pwd-strength-bars {
		display: flex;
		align-items: center;
	}

	.pwd-strength-bars i {
		width: 40px;
		height: 6px;
		margin-right: 4px;
		background-color: #dcdfe6;
	}

	.pwd-strength-bars.weak i:nth-child(1) {
		background-color: #ff5a36;
	}

	.pwd-strength-bars.medium i:nth-child(1) {
		background-color: #ff5a36;
	}

	.pwd-strength-bars.medium i:nth-child(2) {
		background-color: #f7b733;
	}

	.pwd-strength-bars.strong i:nth-child(1) {
		background-color: #ff5a36;
	}

	.pwd-strength-bars.strong i:nth-child(2) {
		background-color: #f7b733;
	}

	.pwd-strength-bars.strong i:nth-child(3) {
		background-color: #20bf55;
	}

	.pwd-strength-text {
		width: 24px;
		margin-left: 4px;
		text-align: right;
	}

	.pwd-rule-tip {
		margin-top: 10px;
		line-height: 22px;
		color: #909399;
		font-size: 14px;
	}
</style>